"use client"
import "@/components/header/header.css"
import PAGE_TYPE from "@/constants/pageType";
import LogoSVG from "@/assets/icons/newLogoRed.svg";
import { EXPOSURE_RECORD, sendClickTrack } from "@/tracks/25061";

interface Props {
  pageType: PAGE_TYPE
  isHeaderDisabled?: boolean
}

const HeaderLogo = ({ pageType, isHeaderDisabled=false }: Props) => {

  const handleLogo = () => {
    sendClickTrack.Header_Logo();
    const urlParams = new URLSearchParams(location.search);
    const returnUrl = urlParams.get("returnUrl");
    if (returnUrl && (returnUrl.startsWith("https://") || returnUrl.startsWith("http://"))) {
      try {
        const url = new URL(returnUrl);
        location.href = `${url.protocol}//${url.hostname}`;
      }
      catch (error) {
        console.error("Error header logo click", error);
        location.href = '/';
      }
    }
    else {
      location.href = '/';
    }
  }

  return (
    <button
      className="logo"
      aria-label="Logo"
      exptag={"exp|" + EXPOSURE_RECORD.Header_Logo_Expo}
      data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
      onClick={handleLogo}
    >
      {isHeaderDisabled || pageType === PAGE_TYPE.HOME ? <LogoSVG color="#FFF" width="110px" height="30px" /> : <LogoSVG color="#cc0c1c" width="110px" height="30px" />}
    </button>
  )
}

export default HeaderLogo;